import { EventTypes } from 'redux-segment'
import getConfig from './config/getConfig'
import apiRequest from './utils/api'
import get from 'lodash/get'

const isProduction = getConfig().projectId === 'school-5927d'
const deployment = isProduction ? 'production' : 'development'

const rpc = (method, data, meta) => {
  const thunk = async () => {
    return apiRequest(`api/${method}`, data)
  }
  thunk.meta = meta
  return thunk
}

const trackLogout = () => (dispatch, getState) => {
  if (!get(getState(), 'user') || !get(getState(), 'analytics.id')) {
    return
  }

  const type = 'LOGOUT'

  return dispatch({
    type,
    meta: {
      analytics: [
        {
          eventType: EventTypes.track,
          eventPayload: {
            event: type,
            properties: {
              deployment
            }
          }
        },
        {
          eventType: EventTypes.reset
        }
      ]
    }
  })
}

/** @todo fix?! This is so, so broken. Getting `uid` is broken, and ({ getFirebase }) isn't actually a thing. */
const trackLogin = ({ user: userData }) => async (
  dispatch,
  getState,
  { getFirebase }
) => {
  const { uid } = userData.user || {}
  const analyticsId = get(getState(), 'analytics.id')

  if (!uid || !analyticsId) {
    return
  }

  const user = await getFirebase()
    .firestore()
    .collection('users')
    .doc(uid)
    .get()
    .then(doc => ({ ...doc.data(), id: doc.id }))

  const type = 'LOGIN'

  return dispatch({
    type,
    meta: {
      analytics: [
        getIdentifyInfo(analyticsId, user),
        {
          eventType: EventTypes.track,
          eventPayload: {
            event: type,
            properties: {
              userId: analyticsId,
              deployment
            }
          }
        }
      ]
    }
  })
}

const identify = (user = {}) => async (dispatch, getState) => {
  const analyticsId = get(getState(), 'analytics.id')

  if (!user.uid || !analyticsId) {
    return
  }

  /** @todo initialize firebase in shared package, and import this as a ref from firestore/refs.js */
  const classes = await window.firebase
    .firestore()
    .collection('classes')
    .where('members', 'array-contains', user.uid)
    .where('archived', '==', false)
    .get()
    .then(qSnap => (qSnap.empty ? [] : qSnap.docs.map(doc => doc.id)))

  return dispatch({
    type: 'IDENTIFY',
    meta: {
      analytics: getIdentifyInfo(analyticsId, user, classes)
    }
  })
}

function getIdentifyInfo(id, userData, classes) {
  return {
    eventType: EventTypes.identify,
    eventPayload: {
      userId: id,
      traits: {
        classes,
        description: userData.role,
        id,
        school: userData.school
      }
    }
  }
}

const ignorePaths = ['/authhandler']

const trackPageViews = () => (dispatch, getState) => {
  if (!get(getState(), 'user') || !get(getState(), 'analytics.id')) {
    return
  }

  const { pathname } = window.location

  if (ignorePaths.indexOf(pathname) === -1 && isProduction) {
    dispatch({
      type: 'PAGE_VIEW',
      meta: {
        analytics: EventTypes.page
      }
    })
  }
}

const setUrl = (url, opts = {}) => (dispatch, getState, { history }) => {
  return history.push(url, opts)
}

const replaceUrl = (url, opts = {}) => (dispatch, getState, { history }) => {
  return history.replace(url, opts)
}

export {
  setUrl,
  replaceUrl,
  rpc,
  trackPageViews,
  identify,
  trackLogin,
  trackLogout
}
